import React, { useEffect, useState } from "react";
import { FormProvider } from "@/providers";
import { addListingValidationSchema } from "@/utils";
import { ADD_LISTING_DEFAULT_VALUES } from "@/constants";
import { Navigate, useLocation } from "react-router-dom";
import { ListingTypeForm } from "@/Components/Add";
import { axiosInstanceWithToken } from "@/helpers/axios";

export const AddListingFragment = () => {
    const location = useLocation();
    const { listing_type, listId = "", isDuplicate = false, isDraft = false } = location.state || {};

    const [defaultValues, setDefaultValues] = useState(listing_type ? {
        ...ADD_LISTING_DEFAULT_VALUES,
        listing_type,
    } : ADD_LISTING_DEFAULT_VALUES);

    const [isLoading, setIsLoading] = useState(!!listId);

    const parseStringToArray = (value) => {
        if (Array.isArray(value)) return value; // If it's already an array, return as is
        if (typeof value === 'string') {
            return value.replace(/["\[\]\\]/g, '').split(',');
        }
        return []; // Return an empty array if value is neither string nor array
    };

    const user = JSON.parse(localStorage.getItem('data'));

    if (parseInt(user?.profile_completeness) < 100) {
        Navigate('/profile');
    }

    useEffect(() => {



        if (listId) {

            const url = isDraft ? `/draft/${listId}` : `/listing/${listId}`;

            setIsLoading(true);

            axiosInstanceWithToken.get(url)
                .then((res) => {
                    const fetchedData = res?.data?.listing || res?.data?.draft;
                    if (isDuplicate) {
                        delete fetchedData?.id;
                        fetchedData.blocked_dates = [{
                            start_date: new Date(),
                            end_date: new Date(),
                            type: 'blocked'
                        }];
                    }
                    if (fetchedData) {
                        setDefaultValues((prevValues) => ({
                            ...prevValues,
                            ...fetchedData,
                            draft_id: isDraft ? listId : ``,
                            features: fetchedData?.features ? fetchedData?.features.map((feature) => ({
                                id: feature?.feature_id || feature?.id,
                                feature_id: feature?.feature_id || feature?.id,
                                name: feature?.name,
                                sub_features: feature?.sub_features?.map((subFeature) => subFeature?.id || subFeature),
                            })) || [] : [],
                            extra_service: (listId ? fetchedData.extra_services : fetchedData.extra_service)?.map((item) => {
                                return {
                                    ...item,
                                    price: parseFloat(item?.price || 0),
                                    quantity: parseFloat(item?.quantity || 1),
                                };
                            }),
                            extra_services: (listId ? fetchedData.extra_services : fetchedData.extra_service)?.length > 0 ? 1 : 0,
                            airports: fetchedData?.airports?.map((airport) => {
                                return {
                                    ...airport,
                                    fuel: parseStringToArray(airport?.fuel),
                                    surface: parseStringToArray(airport?.surface),
                                    ctaf_unicom: parseFloat(airport?.ctaf_unicom),
                                }
                            }),
                            listing_type: fetchedData.listing_type,
                            cancellation_policy_long: isDraft ? parseInt(fetchedData.cancellation_policy_long) : fetchedData.cancellation_policy_long?.id,
                            cancellation_policy_short: isDraft ? parseInt(fetchedData.cancellation_policy_short) : fetchedData.cancellation_policy_short?.id,
                            blocked_dates: fetchedData?.blocked_dates?.map(date => ({
                                start_date: new Date(date.start_date),
                                end_date: new Date(date.end_date),
                                type: date.type || 'blocked'
                            })) || [],
                        }));
                    }
                })
                .catch((error) => {
                    console.error("Error fetching listing data:", error);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        }
    }, [isDraft, isDuplicate, listId]);

    if (isLoading) {
        return (
            <div className="flex flex-col items-center justify-center h-screen gap-5">
                <img
                    className="h-auto w-36 md:w-44" // Responsive sizes
                    src="/image/fly-inn-logo.svg"
                    alt="Fly Inn Logo"
                />
                <div className="text-2xl text-bold"> Please Wait while we load your data!</div>
            </div>
        );
    }

    console.log(defaultValues)

    return (
        <FormProvider
            validationSchema={addListingValidationSchema}
            defaultValues={defaultValues}
        >
            <ListingTypeForm />
        </FormProvider>
    );
};
